import * as angular from "angular";
import {IntegrationsRequestsService} from "./services/integrations-requests.service";
import {ClientRegistrationResponse} from "./models/client-registration-response.model";
import {Oauth2redirectResponse} from "./models/oauth2-redirect-response.model";

angular
  .module('bringoz.admin.integrations')
  .config(IntegrationsConfig);

/* @ngInject */
function IntegrationsConfig($stateProvider) {

  $stateProvider

    // Integrations view
    .state('integrations', {
      url: '/integrations',
      parent: 'bringoz.site',
      controllerAs: 'vm',
      template: '<integrations-view></integrations-view>',
      controller: function (triBreadcrumbsService, site) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "All"});
        triBreadcrumbsService.addCrumb({name: "Integrations"});
      }
    })

    // Integration view
    .state('integration', {
      url: '/integrations',
      parent: 'bringoz.site',
      controllerAs: 'vm',
      abstract: true,
      template: '<ui-view>'
    })

    // Quickbooks view
    .state('integration.quickbooks', {
      url: '/quickbooks',
      controllerAs: 'vm',
      template: '<quickbooks-integration client-registration="vm.clientRegistration" registration-status="vm.registrationStatus"></quickbooks-integration>',
      controller: function (triBreadcrumbsService, clientRegistration, registrationStatus) {

        this.clientRegistration = clientRegistration;
        this.registrationStatus = registrationStatus;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Quickbooks"});
        triBreadcrumbsService.addCrumb({name: "Integrations", state: "integrations"});
      },
      resolve: {
        clientRegistration: (integrationsRequestsService: IntegrationsRequestsService, siteId: string) => {
          return integrationsRequestsService.getClientRegistration(siteId, 'quickbooks');
        },
        registrationStatus: (siteId: string,
                             integrationsRequestsService: IntegrationsRequestsService,
                             clientRegistration: ClientRegistrationResponse) => {
          return integrationsRequestsService.getQuickbooksRegistrationStatus(siteId, clientRegistration.registrationId);
        }
      }
    })

    // Integrations redirect
    .state('integration.quickbooks-redirect', {
      url: '/quickbooks/redirect?code&:state&:realmId',
      controllerAs: 'vm',
      template: '',
      controller: function ($state, siteId) {
        $state.go('integration.quickbooks', {siteId: siteId}, {notify: true, reload: false, location: 'replace'})
      },
      resolve: {
        clientRegistration: (integrationsRequestsService: IntegrationsRequestsService, siteId: string) => {
          return integrationsRequestsService.getClientRegistration(siteId, 'quickbooks');
        },
        oauth2redirectResponse: ($stateParams,
                                 siteId: string,
                                 splitService,
                                 clientRegistration: ClientRegistrationResponse,
                                 integrationsRequestsService: IntegrationsRequestsService) => {
          // return integrationsRequestsService.registerQuickbooks(siteId, $stateParams.code, $stateParams.state, $stateParams.realmId);
          return integrationsRequestsService.authorizeClientRegistration(siteId, clientRegistration.registrationId, $stateParams.code, $stateParams.state);
        },
        realmId: ($stateParams) => {
          return $stateParams.realmId;
        },
        registrationStatus: (integrationsRequestsService: IntegrationsRequestsService,
                             clientRegistration: ClientRegistrationResponse,
                             oauth2redirectResponse: Oauth2redirectResponse,
                             siteId: string,
                             realmId: string) => {
          return integrationsRequestsService.registerQuickbooks(siteId, clientRegistration.registrationId, realmId);
        }
      }
    })
}
